import React, { Component } from 'react';
import { Route, Redirect, Switch, withRouter } from 'react-router-dom';
import ImageBackground from '../common/imageBackground';
import MealList from './MealList';
import MealSummary from './MealSummary';
import MealSlideshow from './MealSlideshow';
import './styles.css';

class Service1277 extends Component {
  /**************
   * Properties *
   **************/
  /**
   * The service's different screens
   */
  bannerInvisible = {
    visible: false
  };
  breakfastNavigationBar = {
    mainMenu: true,
    back: true,
    backRoute: '/room_service'
  };
  breakfastButtonList = {
    top: 154,
    left: 68
  };
  breakfastHeader = {
    id: 'header',
    src: require('./images/breakfast/1277_elements_category.png'),
    top: 0,
    left: 0,
    width: 1280,
    height: 720
  };
  breakfastGuide = {
    id: 'breakfastGuide',
    src: require('./images/breakfast/Guide_1277_category.png'),
    top: 0,
    left: 0,
    width: 1280,
    height: 720
  };
  breakfastButtons = [
    {
      id: 'breakfastCat1',
      to: '/music/energy/breakfast_cat1',
      highlight: require('./images/breakfast/Breakfast_cat1_HL.png'),
      unhighlight: require('./images/breakfast/Breakfast_cat1_UH.png'),
      alt: 'Breakfast Fruits and Juices'
    },
    {
      id: 'breakfastCat2',
      to: '/music/energy/breakfast_cat2',
      highlight: require('./images/breakfast/Breakfast_cat2_HL.png'),
      unhighlight: require('./images/breakfast/Breakfast_cat2_UH.png'),
      alt: 'Cereals'
    },
    {
      id: 'breakfastCat3',
      to: '/music/energy/breakfast_cat3',
      highlight: require('./images/breakfast/Breakfast_cat3_HL.png'),
      unhighlight: require('./images/breakfast/Breakfast_cat3_UH.png'),
      alt: 'Salads'
    },
    {
      id: 'breakfastCat4',
      to: '/music/energy/breakfast_cat4',
      highlight: require('./images/breakfast/Breakfast_cat4_HL.png'),
      unhighlight: require('./images/breakfast/Breakfast_cat4_UH.png'),
      alt: 'Beverages'
    },
    {
      id: 'breakfastCat5',
      to: '/music/energy/breakfast_cat5',
      highlight: require('./images/breakfast/Breakfast_cat5_HL.png'),
      unhighlight: require('./images/breakfast/Breakfast_cat5_UH.png'),
      alt: 'Breakfast Bakery'
    },
    {
      id: 'breakfastCat6',
      to: '/music/energy/breakfast_cat6',
      highlight: require('./images/breakfast/Breakfast_cat6_HL.png'),
      unhighlight: require('./images/breakfast/Breakfast_cat6_UH.png'),
      alt: 'Bakery Hot Entrees'
    },
    {
      id: 'breakfastCat7',
      to: '/music/energy/breakfast_cat7',
      highlight: require('./images/breakfast/Breakfast_cat7_HL.png'),
      unhighlight: require('./images/breakfast/Breakfast_cat7_UH.png'),
      alt: 'Desserts'
    },
    {
      id: 'breakfastCat8',
      to: '/music/energy/breakfast_cat8',
      highlight: require('./images/breakfast/Breakfast_cat8_HL.png'),
      unhighlight: require('./images/breakfast/Breakfast_cat8_UH.png'),
      alt: 'Condiments'
    }
  ];

  /******************
   * Public methods *
   ******************/

  /**
   * Renders the component.
   *
   * @public
   *
   * @returns {React.Component}  The rendered view of the component.
   *
   **/
  render() {
    return (
      <div className="service-1277">
        <ImageBackground id="background" />
        <Switch>
          <Route path="/room_service/meal/:meal/:page" component={MealSlideshow} />
          <Route
            path="/room_service/meal/:meal"
            render={({ match }) => <Redirect to={`/room_service/meal/${match.params.meal}/1`} />}
          />
          <Route path="/room_service/summary/:meal/:page" component={MealSummary} />
          <Route
            path="/room_service/summary/:meal"
            render={({ match }) => <Redirect to={`/room_service/summary/${match.params.meal}/1`} />}
          />
          <Route path="/room_service/meal_list" component={MealList} />
          <Route path="/room_service" render={() => <Redirect to="/room_service/meal_list" />} />
        </Switch>
      </div>
    );
  }
}

export default withRouter(Service1277);
